<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm back-btn"
                :to="{ name: 'ProvisionList' }"
                ><i class="icon-left"></i>
              </router-link>
              <span>{{ is_edit ? "Edit" : "Create" }} Device Activation</span>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Provision</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <form @submit.prevent="handleSubmission()" method="POST" novalidate>
          <div class="card" id="Provision">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-body">
              <div class="row">
                <!-- <div class="col-md-4 form-group required">
                    <label class="control-label">Router</label>
                    <multiselect
                      v-model="value.ap_wi_mac"
                      :options="Object.keys(pre.routerList)"
                      :custom-label="(opt) => pre.routerList[opt]"
                      placeholder="Select Router"
                      :searchable="true"
                      :multiple="false"
                      id="ap_wi_mac"
                      v-bind:class="{ 'has-error': errors.has('ap_wi_mac') }"
                      v-validate="'required'"
                      name="router"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('router')">
                      {{ errors.first("router") }}
                    </div>
                  </div> -->
                <div class="col-md-4 form-group required">
                  <label class="control-label">Name</label>
                  <div class="position-relative name">
                    <input
                      type="text"
                      id="username"
                      name="username"
                      v-model="value.initial_configuration.username"
                      v-validate="'required'"
                      class="form-control username"
                      placeholder="Name"
                    />
                  </div>
                  <div class="help text-danger" v-show="errors.has('username')">
                    {{ errors.first("username") }}
                  </div>
                </div>
                <div class="col-md-4 form-group required">
                  <label class="control-label">Email</label>
                  <div class="position-relative activation-email">
                    <!--                    <i v-if="is_edit" class="icon-edit" @click="openModal('activationEmailWarning')"></i>-->
                    <input
                      type="text"
                      id="activation_email"
                      name="activation_email"
                      v-model="value.initial_configuration.activation_email"
                      v-validate="'required|email'"
                      class="form-control activation_email"
                      placeholder="Email"
                    />
                  </div>
                  <div
                    class="help text-danger"
                    v-show="errors.has('activation_email')"
                  >
                    {{ errors.first("activation_email") }}
                  </div>
                </div>
                <!-- <div class="col-md-6 form-group required">
                  <label class="control-label">Time Zone</label>
                  <multiselect v-model="value.zone_time" :options="Object.keys(pre.timeZoneList)"
                    :custom-label="(opt) => pre.timeZoneList[opt]" placeholder="Select Time Zone" :searchable="true"
                    :multiple="false" id="zone_time" v-bind:class="{
                      'has-error': errors.has('zone_time'),
                    }" v-validate="'required'" name="zone_time">
                  </multiselect>

                  <div class="help text-danger" v-show="errors.has('zone_time')">
                    {{ errors.first("zone_time") }}
                  </div>
                </div> -->
                <div class="col-md-4 form-group">
                  <label class="control-label">MAC ID</label>
                  <input
                    type="text"
                    name="mac_id"
                    v-model="value.mac"
                    class="form-control"
                    placeholder="MAC ID"
                    readonly
                  />
                  <div class="help text-danger"></div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="control-label">Product</label>
                  <input
                    type="text"
                    name="product"
                    v-model="value.twoghz_ssid"
                    class="form-control"
                    placeholder="Product"
                    readonly
                  />
                  <div class="help text-danger"></div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="control-label">Device</label>
                  <input
                    type="text"
                    name="device"
                    v-model="value.device_type"
                    class="form-control"
                    placeholder="Device"
                    readonly
                  />
                  <div class="help text-danger"></div>
                </div>
                <div class="col-md-4 form-group required">
                  <label class="control-label">Device Name</label>
                  <input
                    type="text"
                    id="device_name"
                    name="device_name"
                    v-model="value.initial_configuration.device_name"
                    v-validate="'required|regex:^[a-zA-Z0-9 ]+$|max:20'"
                    class="form-control device_name"
                    placeholder="Device Name"
                  />

                  <div
                    class="help text-danger"
                    v-show="errors.has('device_name')"
                  >
                    <span
                      v-if="
                        errors.first('device_name') ===
                        'The device name field format is invalid.'
                      "
                    >
                      Device name can only contain letters, numbers, and spaces.
                    </span>
                    <span
                      v-else-if="
                        errors.first('device_name') ===
                        'The device name field may not be greater than 20 characters.'
                      "
                    >
                      Device name cannot exceed 20 characters.
                    </span>
                    <span v-else>{{ errors.first("device_name") }}</span>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label class="control-label">Activation Date</label>
                  <el-date-picker
                    class="w-100"
                    v-model="value.account.activation_date"
                    type="date"
                    placeholder="Pick a day"
                  >
                  </el-date-picker>
                  <div class="help text-danger"></div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                  <label class="control-label">licence</label>
                  <input
                    type="text"
                    v-model="value.sgrp"
                    placeholder="Select licence"
                    class="form-control"
                    id="licence"
                    v-validate="'required'"
                    name="licence"
                    readonly
                  />
                  <div class="help text-danger"></div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                  <label class="control-label">Activation Status</label>
                  <!--                  <input type="text" name="status"  v-model="value.activation_status" class="form-control" placeholder="Due Activation" />-->
                  <!--                  <div class="help text-danger"></div>-->

                  <div
                    v-if="value.activation_status == 'Due Activation'"
                    class="form-control align-items-center readonly"
                  >
                    <span class="select-status bg-secondary"></span>
                    Due Activation
                  </div>
                  <div
                    v-else-if="value.activation_status == 'Activated'"
                    class="form-control align-items-center readonly"
                  >
                    <span class="select-status bg-success"></span>
                    Activate
                  </div>
                  <div
                    v-else-if="value.activation_status == 'De-Activated'"
                    class="form-control align-items-center readonly"
                  >
                    <span class="select-status bg-danger"></span>
                    De-Activate
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body">
              <h4 class="card-common-title p-0 mb-3 pb-3 border-bottom">
                Advanced Settings
              </h4>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="control-label">WAN Auto Config</label>
                  <multiselect
                    v-model="
                      value.initial_configuration.wan_configure_automatically
                    "
                    :options="Object.keys(pre.configOptions)"
                    :custom-label="(opt) => pre.configOptions[opt]"
                    placeholder="Select WAN Auto Config"
                    :searchable="true"
                    :multiple="false"
                    id="wan_configure_automatically"
                    v-bind:class="{
                      'has-error': errors.has('wan_configure_automatically'),
                    }"
                    name="WAN Auto Config"
                  >
                  </multiselect>
                  <div
                    class="help text-danger"
                    v-show="errors.has('wan_configure_automatically')"
                  >
                    {{ errors.first("wan_configure_automatically") }}
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  value.initial_configuration.wan_configure_automatically == 1
                "
              >
                <div class="col-md-12">
                  <div class="row">
                    <div class="col form-group">
                      <label class="control-label">ISP</label>
                      <multiselect
                        v-model="value.initial_configuration.wan_isp_type"
                        :options="Object.keys(pre.ispOptions)"
                        :custom-label="(opt) => pre.ispOptions[opt]"
                        placeholder="Select ISP"
                        :searchable="true"
                        @input="setNetwork"
                        :multiple="false"
                        id="wan_isp_type"
                        v-bind:class="{
                          'has-error': errors.has('wan_isp_type'),
                        }"
                        name="ISP"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_isp_type')"
                      >
                        {{ errors.first("wan_isp_type") }}
                      </div>
                    </div>

                    <div class="col form-group required">
                      <label class="control-label">Network protocol</label>
                      <multiselect
                        v-model="value.initial_configuration.wan_network_type"
                        :options="Object.keys(pre.networkOptions)"
                        :custom-label="(opt) => pre.networkOptions[opt]"
                        placeholder="Select Network"
                        :searchable="true"
                        :multiple="false"
                        :disabled="
                          value.initial_configuration.wan_isp_type == 'unify' ||
                          value.initial_configuration.wan_isp_type == 'maxis'
                        "
                        id="wan_network_type"
                        name="wan_network_type"
                        v-validate="wanNetworkTypeRule"
                        v-bind:class="{
                          'has-error': errors.has('wan_network_type'),
                        }"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_network_type')"
                      >
                        {{ errors.first("wan_network_type") }}
                      </div>
                    </div>
                    <div
                      class="col"
                      v-if="
                        value.initial_configuration.wan_network_type == 'dhcp'
                      "
                    >
                      <div class="form-group">
                        <label class="control-label"
                          >Configure Automatically</label
                        >
                        <multiselect
                          v-model="
                            value.initial_configuration
                              .wan_dhcp_configure_automatically
                          "
                          :options="Object.keys(pre.configAutomaticallyOptions)"
                          :custom-label="
                            (opt) => pre.configAutomaticallyOptions[opt]
                          "
                          placeholder="Select Configure Automatically"
                          :searchable="true"
                          :multiple="false"
                          id="wan_dhcp_configure_automatically"
                          v-bind:class="{
                            'has-error': errors.has(
                              'wan_dhcp_configure_automatically'
                            ),
                          }"
                          name="dhcp configure automatically"
                        >
                        </multiselect>
                        <div
                          class="help text-danger"
                          v-show="
                            errors.has('wan_dhcp_configure_automatically')
                          "
                        >
                          {{ errors.first("wan_dhcp_configure_automatically") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="row"
                    v-if="
                      value.initial_configuration
                        .wan_dhcp_configure_automatically == 0
                    "
                  >
                    <div class="col-md-4 form-group required">
                      <label class="control-label">Preferred DNS</label>
                      <input
                        type="text"
                        id="wan_dhcp_preferred_dns"
                        name="wan_dhcp_preferred_dns"
                        v-model="
                          value.initial_configuration.wan_dhcp_preferred_dns
                        "
                        v-validate="wanDhcpPreferedDnsRules"
                        class="form-control wan_dhcp_preferred_dns"
                        placeholder="Preferred DNS"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_dhcp_preferred_dns')"
                      >
                        {{ errors.first("wan_dhcp_preferred_dns") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group">
                      <label class="control-label">Alternative DNS</label>
                      <input
                        type="text"
                        id="wan_dhcp_alternat_dns"
                        name="dhcp alternat dns"
                        v-model="
                          value.initial_configuration.wan_dhcp_alternat_dns
                        "
                        class="form-control wan_dhcp_alternat_dns"
                        placeholder="Alternative DNS"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_dhcp_alternat_dns')"
                      >
                        {{ errors.first("wan_dhcp_alternat_dns") }}
                      </div>
                    </div>

                    <div
                      v-if="value.initial_configuration.wan_isp_type == 'other'"
                      class="col-md-4 form-group"
                    >
                      <label class="control-label">VLAN ID</label>
                      <input
                        type="text"
                        id="wan_pppoe_vlan_id"
                        name="wan_pppoe_vlan_id"
                        v-model="value.initial_configuration.wan_pppoe_vlan_id"
                        class="form-control wan_pppoe_vlan_id"
                        placeholder="VLAN ID"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_pppoe_vlan_id')"
                      >
                        {{ errors.first("wan_pppoe_vlan_id") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="row"
                    v-if="
                      value.initial_configuration.wan_network_type == 'pppoe'
                    "
                  >
                    <div class="col-md-4 form-group required">
                      <label class="control-label">User Name</label>
                      <input
                        type="text"
                        id="wan_pppoe_username"
                        name="wan_pppoe_username"
                        v-model="value.initial_configuration.wan_pppoe_username"
                        v-validate="wanPppoeUsernameRules"
                        class="form-control wan_pppoe_username"
                        placeholder="User Name"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_pppoe_username')"
                      >
                        {{ errors.first("wan_pppoe_username") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group required">
                      <label class="control-label">Password</label>
                      <input
                        type="text"
                        id="wan_pppoe_password"
                        name="wan_pppoe_password"
                        v-model="value.initial_configuration.wan_pppoe_password"
                        v-validate="wanPppoePasswordRules"
                        class="form-control wan_pppoe_password"
                        placeholder="Password"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_pppoe_password')"
                      >
                        {{ errors.first("wan_pppoe_password") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group">
                      <label class="control-label"
                        >Configure Automatically</label
                      >
                      <multiselect
                        v-model="
                          value.initial_configuration
                            .wan_pppoe_configure_automatically
                        "
                        :options="Object.keys(pre.configAutomaticallyOptions)"
                        :custom-label="
                          (opt) => pre.configAutomaticallyOptions[opt]
                        "
                        placeholder="Select Configure Automatically"
                        :searchable="true"
                        :multiple="false"
                        id="wan_pppoe_configure_automatically"
                        v-bind:class="{
                          'has-error': errors.has(
                            'wan_pppoe_configure_automatically'
                          ),
                        }"
                        name="pppoe configure automatically"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_pppoe_configure_automatically')"
                      >
                        {{ errors.first("wan_pppoe_configure_automatically") }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div
                        class="row"
                        v-if="
                          value.initial_configuration
                            .wan_pppoe_configure_automatically == 0
                        "
                      >
                        <div class="col-md-4 form-group">
                          <label class="control-label"
                            >Access Concentrator</label
                          >
                          <input
                            type="text"
                            id="wan_pppoe_access_concentrator"
                            name="wan_pppoe_access_concentrator"
                            v-model="
                              value.initial_configuration
                                .wan_pppoe_access_concentrator
                            "
                            class="form-control wan_pppoe_access_concentrator"
                            placeholder="Access Concentrator"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wan_pppoe_access_concentrator')"
                          >
                            {{ errors.first("wan_pppoe_access_concentrator") }}
                          </div>
                        </div>
                        <div class="col-md-4 form-group">
                          <label class="control-label">Service Name</label>
                          <input
                            type="text"
                            id="wan_pppoe_service_name"
                            name="wan_pppoe_service_name"
                            v-model="
                              value.initial_configuration.wan_pppoe_service_name
                            "
                            class="form-control wan_pppoe_service_name"
                            placeholder="Service Name"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wan_pppoe_service_name')"
                          >
                            {{ errors.first("wan_pppoe_service_name") }}
                          </div>
                        </div>

                        <div class="col-md-4 form-group required">
                          <label class="control-label">Preferred DNS</label>
                          <input
                            type="text"
                            id="wan_pppoe_preferred_dns"
                            name="wan_pppoe_preferred_dns"
                            v-model="
                              value.initial_configuration
                                .wan_pppoe_preferred_dns
                            "
                            v-validate="wanPppoePreferredDnsRules"
                            class="form-control wan_pppoe_preferred_dns"
                            placeholder="Preferred DNS"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wan_pppoe_preferred_dns')"
                          >
                            {{ errors.first("wan_pppoe_preferred_dns") }}
                          </div>
                        </div>

                        <div class="col-md-4 form-group required">
                          <label class="control-label">Alternative DNS</label>
                          <input
                            type="text"
                            id="wan_pppoe_alternat_dns"
                            name="wan_pppoe_alternat_dns"
                            v-model="
                              value.initial_configuration.wan_pppoe_alternat_dns
                            "
                            v-validate="wanPppoeAltDnsRules"
                            class="form-control wan_pppoe_alternat_dns"
                            placeholder="Alternative DNS"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wan_pppoe_alternat_dns')"
                          >
                            {{ errors.first("wan_pppoe_alternat_dns") }}
                          </div>
                        </div>

                        <div
                          v-if="
                            value.initial_configuration.wan_isp_type == 'other'
                          "
                          class="col-md-4 form-group"
                        >
                          <label class="control-label">VLAN ID</label>
                          <input
                            type="text"
                            id="wan_pppoe_vlan_id"
                            name="wan_pppoe_vlan_id"
                            v-model="
                              value.initial_configuration.wan_pppoe_vlan_id
                            "
                            class="form-control wan_pppoe_vlan_id"
                            placeholder="VLAN ID"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('wan_pppoe_vlan_id')"
                          >
                            {{ errors.first("wan_pppoe_vlan_id") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="row"
                    v-if="
                      value.initial_configuration.wan_network_type == 'static'
                    "
                  >
                    <div class="col-md-4 form-group required">
                      <label class="control-label">IP Address</label>
                      <input
                        type="text"
                        id="wan_static_ip_address"
                        name="wan_static_ip_address"
                        v-model="
                          value.initial_configuration.wan_static_ip_address
                        "
                        v-validate="wanStaticIpRules"
                        class="form-control wan_static_ip_address"
                        placeholder="IP Address"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_static_ip_address')"
                      >
                        {{ errors.first("wan_static_ip_address") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group required">
                      <label class="control-label">Subnet Mask</label>
                      <input
                        type="text"
                        id="wan_static_subnet_mask"
                        name="wan_static_subnet_mask"
                        v-model="
                          value.initial_configuration.wan_static_subnet_mask
                        "
                        v-validate="wanStaticIpRules"
                        class="form-control wan_static_subnet_mask"
                        placeholder="Subnet Mask"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_static_subnet_mask')"
                      >
                        {{ errors.first("wan_static_subnet_mask") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group required">
                      <label class="control-label">Default Gateway</label>
                      <input
                        type="text"
                        id="wan_static_default_gateway"
                        name="wan_static_default_gateway"
                        v-model="
                          value.initial_configuration.wan_static_default_gateway
                        "
                        v-validate="wanStaticIpRules"
                        class="form-control wan_static_default_gateway"
                        placeholder="Default Gateway"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_static_default_gateway')"
                      >
                        {{ errors.first("wan_static_default_gateway") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group required">
                      <label class="control-label">Preferred DNS</label>
                      <input
                        type="text"
                        id="wan_static_preferred_dns"
                        name="wan_static_preferred_dns"
                        v-model="
                          value.initial_configuration.wan_static_preferred_dns
                        "
                        v-validate="wanStaticIpRules"
                        class="form-control wan_static_preferred_dns"
                        placeholder="Preferred DNS"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_static_preferred_dns')"
                      >
                        {{ errors.first("wan_static_preferred_dns") }}
                      </div>
                    </div>

                    <div class="col-md-4 form-group">
                      <label class="control-label">Alternative DNS</label>
                      <input
                        type="text"
                        id="wan_static_alternat_dns"
                        name="wan_static_alternat_dns"
                        v-model="
                          value.initial_configuration.wan_static_alternat_dns
                        "
                        class="form-control wan_static_alternat_dns"
                        placeholder="Alternative DNS"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_static_alternat_dns')"
                      >
                        {{ errors.first("wan_static_alternat_dns") }}
                      </div>
                    </div>

                    <div
                      v-if="value.initial_configuration.wan_isp_type == 'other'"
                      class="col-md-4 form-group"
                    >
                      <label class="control-label">VLAN ID</label>
                      <input
                        type="text"
                        id="wan_pppoe_vlan_id"
                        name="wan_pppoe_vlan_id"
                        v-model="value.initial_configuration.wan_pppoe_vlan_id"
                        class="form-control wan_pppoe_vlan_id"
                        placeholder="VLAN ID"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('wan_pppoe_vlan_id')"
                      >
                        {{ errors.first("wan_pppoe_vlan_id") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="card-common-title p-0 mb-3 pb-3 border-bottom"></h4>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="control-label">LAN Auto Config</label>
                  <multiselect
                    v-model="
                      value.initial_configuration.lan_configure_automatically
                    "
                    :options="Object.keys(pre.configOptions)"
                    :custom-label="(opt) => pre.configOptions[opt]"
                    placeholder="Select LAN Auto Config"
                    :searchable="true"
                    :multiple="false"
                    id="lan_configure_automatically"
                    v-bind:class="{
                      'has-error': errors.has('lan_configure_automatically'),
                    }"
                    name="LAN Auto Config"
                  >
                  </multiselect>
                  <div
                    class="help text-danger"
                    v-show="errors.has('lan_configure_automatically')"
                  >
                    {{ errors.first("lan_configure_automatically") }}
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  value.initial_configuration.lan_configure_automatically == 1
                "
              >
                <div class="col-md-3 form-group required">
                  <label class="control-label">IP Address</label>
                  <input
                    type="text"
                    id="lan_ip"
                    name="lan_ip"
                    v-model="value.initial_configuration.lan_ip"
                    @keyup="setDHCPIP()"
                    class="form-control lan_ip"
                    placeholder="IP Address"
                    v-validate="lanIpRules"
                  />
                  <div class="help text-danger" v-show="errors.has('lan_ip')">
                    {{ errors.first("lan_ip") }}
                  </div>
                </div>
                <div class="col-md-3 form-group required">
                  <label class="control-label">Subnet Mask</label>
                  <multiselect
                    v-model="value.initial_configuration.lan_subnet_mask"
                    :options="pre.subnetMasks"
                    placeholder="Select Subnet Mask"
                    v-validate="lanSubnetMaskRules"
                    :searchable="true"
                    :multiple="false"
                    id="lan_subnet_mask"
                    v-bind:class="{
                      'has-error': errors.has('lan_subnet_mask'),
                    }"
                    name="lan_subnet_mask"
                  >
                  </multiselect>
                  <div
                    class="help text-danger"
                    v-show="errors.has('lan_subnet_mask')"
                  >
                    {{ errors.first("lan_subnet_mask") }}
                  </div>
                </div>
                <div class="col-md-3 form-group required">
                  <label class="control-label">Start IP</label>
                  <input
                    type="text"
                    id="lan_start_ip"
                    name="lan_start_ip"
                    v-model="value.initial_configuration.lan_start_ip"
                    class="form-control lan_start_ip"
                    placeholder="Start IP"
                    v-validate="lanStartIpRules"
                  />
                  <div
                    class="help text-danger"
                    v-show="errors.has('lan_start_ip')"
                  >
                    {{ errors.first("lan_start_ip") }}
                  </div>
                </div>
                <div class="col-md-3 form-group required">
                  <label class="control-label">End IP</label>
                  <input
                    type="text"
                    id="initial_configuration.lan_end_ip"
                    name="lan_end_ip"
                    v-model="value.initial_configuration.lan_end_ip"
                    class="form-control lan_end_ip"
                    placeholder="End IP"
                    v-validate="lanEndIpRules"
                  />
                  <div
                    class="help text-danger"
                    v-show="errors.has('lan_end_ip')"
                  >
                    {{ errors.first("lan_end_ip") }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="value.application_alias.voip_enable == 1">
            <div class="card mt-3">
              <div class="p-4">
                <div class="panel-body">
                  <div class="switch-row justify-content-between">
                    <h4 class="card-common-title p-0">
                      <i class="fas fa-phone-alt mr-2" aria-hidden="true"></i>
                      VoIP
                    </h4>
                    <el-switch
                      v-model="value.voip_configuration.voip_enable"
                      active-color="#009E9D"
                      inactive-color="#E5E5E5"
                    >
                    </el-switch>
                  </div>
                </div>
                <el-collapse-transition>
                  <div
                    class="VoIP-content"
                    v-show="value.voip_configuration.voip_enable"
                  >
                    <div class="pt-3">
                      <div class="row">
                        <div class="col-md-4 form-group required">
                          <label class="control-label">Caller ID</label>
                          <input
                            type="text"
                            id="display_name"
                            name="display_name"
                            v-model="value.voip_configuration.display_name"
                            v-validate="callerIdRules"
                            class="form-control"
                            placeholder="JaneA"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('display_name')"
                          >
                            {{ errors.first("display_name") }}
                          </div>
                        </div>
                        <div class="col-md-4 form-group required">
                          <label class="control-label">VOiP Number</label>
                          <input
                            type="text"
                            id="sip_number"
                            name="sip_number"
                            v-model="value.voip_configuration.sip_number"
                            v-validate="sipNumberRules"
                            class="form-control"
                            placeholder="0123456789"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('sip_number')"
                          >
                            {{ errors.first("sip_number") }}
                          </div>
                        </div>
                        <!-- <div class="col-md-4 form-group">
                          <label class="control-label">SIP Server</label>
                          <el-input
                            placeholder="Enter value"
                            v-model="value.voip_configuration.sip_server"
                            v-validate="{
                              required: true,
                              regex: value.voip_configuration.sip_server_type === 'ip'
                                ? /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                                : /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z]{2,6})+$/
                            }"
                            class="input-with-select"
                          >
                            <el-select
                              v-model="value.voip_configuration.sip_server_type"
                              slot="prepend"
                              style="width: 110px"
                            >
                              <el-option label="IP" value="ip"></el-option>
                              <el-option label="Domain" value="domain"></el-option>
                            </el-select>
                          </el-input>
                          <div
                            class="help text-danger"
                            v-show="errors.has('sip_server')"
                          >
                            {{ errors.first("sip_server") }}
                          </div>
                        </div> -->
                        <div class="col-md-4 form-group required">
                          <label class="control-label">SIP Server</label>
                          <el-input
                            type="text"
                            id="sip_server"
                            name="sip_server"
                            placeholder="Enter value"
                            v-model="value.voip_configuration.sip_server"
                            v-validate="sipServerRules"
                            class="input-with-select"
                            @input="validateField('sip_server')"
                          >
                            <el-select
                              v-model="value.voip_configuration.sip_server_type"
                              slot="prepend"
                              style="width: 110px"
                              @change="validateField('sip_server')"
                            >
                              <el-option label="Select" value=""></el-option>
                              <el-option label="IP" value="ip"></el-option>
                              <el-option
                                label="Domain"
                                value="domain"
                              ></el-option>
                            </el-select>
                          </el-input>

                          <div
                            class="help text-danger"
                            v-show="errors.has('sip_server')"
                          >
                            <span
                              v-if="!value.voip_configuration.sip_server_type"
                            >
                              Please select server type
                            </span>
                            <span
                              v-else-if="
                                value.voip_configuration.sip_server_type ===
                                  'ip' &&
                                !isValidIP(value.voip_configuration.sip_server)
                              "
                            >
                              Please enter a valid IP address (e.g.,
                              192.168.1.1)
                            </span>
                            <span
                              v-else-if="
                                value.voip_configuration.sip_server_type ===
                                  'domain' &&
                                !isValidDomain(
                                  value.voip_configuration.sip_server
                                )
                              "
                            >
                              Please enter a valid domain (e.g., example.com)
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4 form-group required">
                          <label class="control-label">SIP Port</label>
                          <input
                            type="text"
                            id="sip_port"
                            name="sip_port"
                            v-model="value.voip_configuration.sip_port"
                            v-validate="sipPortRules"
                            class="form-control"
                            placeholder="5060"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('sip_port')"
                          >
                            {{ errors.first("sip_port") }}
                          </div>
                        </div>
                        <div class="col-md-4 form-group required">
                          <label class="control-label">Login ID</label>
                          <input
                            type="text"
                            id="login_id"
                            name="login_id"
                            v-model="value.voip_configuration.login_id"
                            v-validate="loginIdRules"
                            class="form-control"
                            placeholder="Login ID"
                          />
                          <div
                            class="help text-danger"
                            v-show="errors.has('login_id')"
                          >
                            {{ errors.first("login_id") }}
                          </div>
                        </div>
                        <div class="col-md-4 form-group required">
                          <label class="control-label">Password</label>
                          <div class="password">
                            <input
                              name="password"
                              v-model.trim="value.voip_configuration.password"
                              v-validate="passwordRules"
                              class="form-control"
                              placeholder="Password"
                              :class="{ 'has-error': errors.has('password') }"
                              :type="showPassword ? 'text' : 'password'"
                            />
                            <span
                              class="password-toggle"
                              @click="togglePassword"
                            >
                              <i
                                :class="{
                                  'icon-eye-off': showPassword,
                                  'icon-eye': !showPassword,
                                }"
                              ></i>
                            </span>
                          </div>

                          <div
                            class="help text-danger"
                            v-show="errors.has('password')"
                          >
                            {{ errors.first("password") }}
                          </div>
                        </div>
                        <!-- <div class="col-md-4 form-group">
                          <label class="control-label">Proxy Server</label>
                          <el-input
                            placeholder="Enter value"
                            v-model="value.voip_configuration.proxy_server"
                            class="input-with-select"
                          >
                            <el-select
                              v-model="value.voip_configuration.proxy_server_type"
                              slot="prepend"
                              style="width: 110px"
                            >
                              <el-option label="IP" value="ip"></el-option>
                              <el-option label="Domain" value="domain"></el-option>
                            </el-select>
                          </el-input>
                          <div
                            class="help text-danger"
                            v-show="errors.has('proxy_server')"
                          >
                            {{ errors.first("proxy_server") }}
                          </div>
                        </div> -->
                        <div class="col-md-12 form-group">
                          <div
                            class="card-common-title p-0 pt-3 d-flex align-items-center justify-content-between"
                          >
                            <label class="fw-500 m-0">Proxy Enable</label>
                            <el-switch
                              v-model="value.voip_configuration.proxy_enable"
                              active-color="#009E9D"
                              inactive-color="#E5E5E5"
                            >
                            </el-switch>
                          </div>
                        </div>
                        <el-collapse-transition>
                          <div
                            class="col-md-12"
                            v-if="value.voip_configuration.proxy_enable"
                          >
                            <div class="row">
                              <div class="col-md-6 form-group">
                                <label class="control-label"
                                  >Proxy Server</label
                                >
                                <el-input
                                  type="text"
                                  id="proxy_server"
                                  name="proxy_server"
                                  placeholder="Enter value"
                                  v-model="
                                    value.voip_configuration.proxy_server
                                  "
                                  v-validate="proxyServerRules"
                                  class="input-with-select"
                                  @input="validateField('proxy_server')"
                                >
                                  <el-select
                                    v-model="
                                      value.voip_configuration.proxy_server_type
                                    "
                                    slot="prepend"
                                    style="width: 110px"
                                    @change="validateField('proxy_server')"
                                  >
                                    <el-option
                                      label="Select"
                                      value=""
                                    ></el-option>
                                    <el-option
                                      label="IP"
                                      value="ip"
                                    ></el-option>
                                    <el-option
                                      label="Domain"
                                      value="domain"
                                    ></el-option>
                                  </el-select>
                                </el-input>

                                <div
                                  class="help text-danger"
                                  v-show="errors.has('proxy_server')"
                                >
                                  <span
                                    v-if="
                                      !value.voip_configuration
                                        .proxy_server_type
                                    "
                                  >
                                    Please select server type
                                  </span>
                                  <span
                                    v-else-if="
                                      value.voip_configuration
                                        .proxy_server_type === 'ip' &&
                                      !isValidIP(
                                        value.voip_configuration.proxy_server
                                      )
                                    "
                                  >
                                    Please enter a valid IP address (e.g.,
                                    192.168.1.1)
                                  </span>
                                  <span
                                    v-else-if="
                                      value.voip_configuration
                                        .proxy_server_type === 'domain' &&
                                      !isValidDomain(
                                        value.voip_configuration.proxy_server
                                      )
                                    "
                                  >
                                    Please enter a valid domain (e.g.,
                                    example.com)
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-6 form-group">
                                <label class="control-label">Proxy Port</label>
                                <input
                                  type="text"
                                  id="proxy_port"
                                  name="proxy_port"
                                  v-model="value.voip_configuration.proxy_port"
                                  v-validate="proxyPortRules"
                                  class="form-control"
                                  placeholder="5060"
                                />
                                <div
                                  class="help text-danger"
                                  v-show="errors.has('proxy_port')"
                                >
                                  {{ errors.first("proxy_port") }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-collapse-transition>
                      </div>
                      <a
                        class="card-common-title p-0 py-3 fw-500 d-flex align-items-center justify-content-between"
                        data-toggle="collapse"
                        href="#PacketizationSettings"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseExample"
                      >
                        Codec & Packetization Settings <i class="icon-down"></i>
                      </a>
                      <div
                        class="collapse packetization"
                        id="PacketizationSettings"
                      >
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Packetization</th>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(codec, index) in value
                                  .voip_configuration.codec_setting"
                                :key="index"
                              >
                                <td>{{ codec.type }}</td>
                                <td>
                                  <el-select
                                    v-model="codec.packetization"
                                    placeholder="Select"
                                  >
                                    <el-option
                                      label="10 ms"
                                      :value="10"
                                    ></el-option>
                                    <el-option
                                      label="20 ms"
                                      :value="20"
                                    ></el-option>
                                    <el-option
                                      label="30 ms"
                                      :value="30"
                                    ></el-option>
                                    <el-option
                                      label="40 ms"
                                      :value="40"
                                    ></el-option>
                                  </el-select>
                                </td>
                                <td v-for="i in 3" :key="i">
                                  <label class="radio">
                                    <!-- <input
                                    type="radio"
                                    :name="'priority-' + index"
                                    :value="i"
                                    v-model="codec.priority"
                                  /> -->
                                    <input
                                      type="radio"
                                      :name="'priority-' + i"
                                      :value="i"
                                      :checked="codec.priority == i"
                                      @change="handlePriorityChange(index, i)"
                                    />
                                    <span class="radio-mark"></span>
                                  </label>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-transition>
              </div>
            </div>
          </div>

          <div class="my-3">
            <button type="submit" class="btn">Submit</button>
            <!--            <button type="submit" v-if="is_edit" class="btn" @click="openModal('activationSuccess')">Activate Device</button>-->
          </div>
        </form>
      </div>
    </section>
    <div
      v-if="showModal === 'activationEmailWarning'"
      class="audra-modal-overlay"
    >
      <div class="audra-modal">
        <h4 class="audra-modal-title">
          <i class="bg-danger mr-2 icon-warning"></i> Warning
        </h4>
        <p>
          This is the <strong>primary email address</strong> that the user will
          use to access their Audra account via App/Portal. Are you sure you
          want to change their email address?
        </p>

        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-outline-secondary mr-2"
            @click="closeModal"
          >
            Cancel
          </button>
          <button type="button" class="btn">Update</button>
        </div>
      </div>
    </div>
    <div v-if="showModal === 'activationSuccess'" class="audra-modal-overlay">
      <div class="audra-modal">
        <h4 class="audra-modal-title">
          <i class="bg-success mr-2 icon-check"></i> Success
        </h4>
        <p class="mb-2">
          The user and their Audra device have been successfully
          <strong>activated</strong>.
        </p>
        <p class="text-muted m-0">
          Do not refresh the page - you will shortly be redirected to the device
          list page
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "ProvisionAdd",
  metaInfo: {
    title: "Provision | Dotlines",
  },

  components: {
    DatePicker,
    ElCollapseTransition,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    showModal: null,
    params: {},
    showVoIP: false,
    showPassword: false,
    codecs: [
      { type: "G711-ulaw", packetization: 20, priority: 1 },
      { type: "G711-alaw", packetization: 20, priority: 2 },
      { type: "G729", packetization: 20, priority: 3 },
    ],
    value: {
      account: {
        device_name: "",
        activation_email: "",
        activation_date: "",
      },
      initial_configuration: {
        lan_ip: "192.168.20.1",
        lan_subnet_mask: "255.255.255.0",
        wan_static_subnet_mask: "255.255.255.0",
        lan_start_ip: "192.168.20.100",
        lan_end_ip: "192.168.20.250",
        wan_dhcp_preferred_dns: "",
        wan_pppoe_preferred_dns: "",
        wan_static_preferred_dns: "",
        wan_dhcp_alternat_dns: "",
        wan_pppoe_alternat_dns: "",
        wan_static_alternat_dns: "",
        wan_isp_type: "other",
        wan_dhcp_configure_automatically: 1,
        wan_pppoe_configure_automatically: 1,
        wan_network_type: "dhcp",
        lan_configure_automatically: 0,
        wan_configure_automatically: 0,
        display_name: "",
        sip_number: "",
        sip_server: "",
        sip_server_type: "",
        sip_port: "",
        login_id: "",
        password: "",
        proxy_server: "",
        proxy_server_type: "",
        proxy_port: "",
      },
      voip_configuration: {
        voip_enable: false,
        proxy_enable: false,
        codec_setting: [],
      },
      application_alias: {},
    },
    pre: {
      audraName: [],
      configOptions: {
        0: "YES",
        1: "NO",
      },
      configAutomaticallyOptions: {
        1: "YES",
        0: "NO",
      },
      ispOptions: {
        unify: "UniFi - Malaysia",
        maxis: "Maxis - Malaysia",
        other: "Regular ISP Profile",
      },
      networkOptions: {
        dhcp: "DHCP",
        pppoe: "PPPoE",
        static: "Static IP Address",
      },
      subnetMasks: [],
      routerList: {},
      timeZoneList: {},
    },
  }),
  computed: {
    isValidIP() {
      return (ip) =>
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          ip
        );
    },
    isValidDomain() {
      return (domain) => {
        const domainRegex =
          /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

        return domainRegex.test(domain);
      };
    },
    callerIdRules() {
      // Build the validation string dynamically
      // Start with the base rules
      let rules = {};
      // Conditionally add the 'required' rule and its message
      if (this.value.voip_configuration.voip_enable) {
        // rules.required = {
        //   rule: true, // This tells VeeValidate to apply the rule
        //   message: 'Caller ID is required when VOip Enable' // Your custom message
        // }
        // rules.required = true
        rules = {
          required: true,
          max: 32,
        };
      }
      return rules;
    },
    sipNumberRules() {
      if (!this.value.voip_configuration.voip_enable) {
        return {};
      }

      return {
        required: true,
        regex: /^(?:\+|00)?\d+(?:\\;ext=\d+)?$/,
      };
    },
    sipPortRules() {
      // Build the validation string dynamically
      let rules = {};
      if (this.value.voip_configuration.voip_enable) {
        rules.required = true;
        rules.numeric = true;
        rules.min_value = 0;
        rules.max_value = 65535;
      }
      return rules;
    },
    loginIdRules() {
      let rules = {};
      if (this.value.voip_configuration.voip_enable) {
        rules.required = true;
        rules.max = 30;
        // rules.regex = /^[a-zA-Z0-9]+$/;
      }
      return rules;
    },

    sipServerRules() {
      let rules = {};

      if (this.value.voip_configuration.voip_enable) {
        rules.required = true;
        if (this.value.voip_configuration.sip_server_type) {
          if (this.value.voip_configuration.sip_server_type === "ip") {
            rules.regex =
              /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            // rules.message = 'Please provide the information in the correct format'
          } else if (
            this.value.voip_configuration.sip_server_type === "domain"
          ) {
            rules.regex =
              /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
            //rules.message = 'Please provide the information in the correct format'
          }
        }
      }

      return rules;
    },
    passwordRules() {
      let rules = {};
      if (this.value.voip_configuration.voip_enable) {
        rules.required = true;
        rules.max = 30;
        // rules.message = 'This is a mandatory field. Please enter the correct value.'
      }

      return rules;
    },
    proxyServerRules() {
      let rules = {};

      if (this.value.voip_configuration.proxy_enable) {
        rules.required = true;
        if (this.value.voip_configuration.proxy_server_type) {
          if (this.value.voip_configuration.proxy_server_type === "ip") {
            rules.regex =
              /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            // rules.message = 'Please provide the information in the correct format'
          } else if (
            this.value.voip_configuration.proxy_server_type === "domain"
          ) {
            rules.regex =
              /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
            // rules.message = 'Please provide the information in the correct format'
          }
        }
      }

      return rules;
    },
    proxyPortRules() {
      let rules = {};

      if (this.value.voip_configuration.proxy_enable) {
        rules.required = true;
        rules.numeric = true;
        rules.min_value = 0;
        rules.max_value = 65535;
        //rules.message = 'Please provide the value in the correct format'
      }

      return rules;
    },
    lanIpRules() {
      let rules = {};

      if (this.value.initial_configuration.lan_configure_automatically == 1) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }
      return rules;
    },

    lanSubnetMaskRules() {
      let rules = {};

      if (this.value.initial_configuration.lan_configure_automatically == 1) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    lanStartIpRules() {
      let rules = {};

      if (this.value.initial_configuration.lan_configure_automatically == 1) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    lanEndIpRules() {
      let rules = {};

      if (this.value.initial_configuration.lan_configure_automatically == 1) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    wanNetworkTypeRule() {
      let rules = {};

      if (this.value.initial_configuration.wan_configure_automatically == 1) {
        rules.required = true;
      }

      return rules;
    },

    wanDhcpPreferedDnsRules() {
      let rules = {};

      if (
        this.value.initial_configuration.wan_dhcp_configure_automatically == "0"
      ) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    wanPppoePreferredDnsRules() {
      let rules = {};

      if (
        this.value.initial_configuration.wan_pppoe_configure_automatically ==
        "0"
      ) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    wanPppoeAltDnsRules() {
      let rules = {};

      if (
        this.value.initial_configuration.wan_pppoe_configure_automatically ==
        "0"
      ) {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }

      return rules;
    },

    wanPppoeUsernameRules() {
      let rules = {};

      if (this.value.initial_configuration.wan_network_type == "pppoe") {
        rules.required = true;
      }

      return rules;
    },

    wanPppoePasswordRules() {
      let rules = {};

      if (this.value.initial_configuration.wan_network_type == "pppoe") {
        rules.required = true;
      }

      return rules;
    },

    wanStaticIpRules() {
      let rules = {};
      if (this.value.initial_configuration.wan_network_type == "static") {
        rules.required = true;
        rules.regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      }
      return rules;
    },
  },
  methods: {
    validateField(fieldName) {
      return true;
      if (!this.value.voip_configuration.voip_enable) {
        return true;
      }
      if (fieldName === "sip_server") {
        const server = this.value.voip_configuration.sip_server;
        const type = this.value.voip_configuration.sip_server_type;

        // Clear previous errors
        this.errors.remove("sip_server");

        if (!type) {
          this.errors.add({
            field: "sip_server",
            msg: "Please select server type",
          });
          return false;
        }

        if (type === "ip" && !this.isValidIP(server)) {
          this.errors.add({
            field: "sip_server",
            msg: "Please enter a valid IP address",
          });
          return false;
        }

        if (type === "domain" && !this.isValidDomain(server)) {
          this.errors.add({
            field: "sip_server",
            msg: "Please enter a valid domain",
          });
          return false;
        }

        return true;
      } else if (fieldName === "proxy_server") {
        const server = this.value.voip_configuration.proxy_server;
        const type = this.value.voip_configuration.proxy_server_type;

        // Clear previous errors
        this.errors.remove("proxy_server");

        if (!type) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please select server type",
          });
          return false;
        }

        if (type === "ip" && !this.isValidIP(server)) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please enter a valid IP address",
          });
          return false;
        }

        if (type === "domain" && !this.isValidDomain(server)) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please enter a valid domain",
          });
          return false;
        }

        return true;
      }
      return true;
    },

    handlePriorityChange(changedIndex, newPriority) {
      this.value.voip_configuration.codec_setting.forEach((codec, idx) => {
        if (idx !== changedIndex && codec.priority + "" === newPriority + "") {
          // Swap priorities
          codec.priority =
            this.value.voip_configuration.codec_setting[changedIndex].priority;
        }
      });
      this.value.voip_configuration.codec_setting[changedIndex].priority =
        newPriority;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    openModal(modalId) {
      this.showModal = modalId;
    },
    closeModal() {
      this.showModal = null;
    },
    handleSubmission() {
      console.log("handleSubmission");
      const _this = this;
      this.$validator
        .validateAll()
        .then((result) => {
          console.log("validateAll", result);
          if (!_this.value.voip_configuration?.voip_enable) {
            _this.value.voip_configuration = {};
          }
          let voipValidationPassed = true;
          if (_this.value.voip_configuration?.voip_enable) {
            voipValidationPassed =
              _this.validateField("sip_server") &&
              _this.validateField("proxy_server");
          }
          console.log("voipValidationPassed", voipValidationPassed);

          if (result && voipValidationPassed) {
            _this.is_loading = true;
            let api_url = "/provisions";
            let method = "POST";
            if (_this.is_edit) {
              api_url = "/provisions/" + _this.$route.params.id;
              method = "PUT";
            }

            api_url += "?accountId=" + LocalStorage.get("accountId");
            const payload = {
              ..._this.value,
              voip_configuration: {
                ..._this.value.voip_configuration,
              },
            };
            axios({
              method: method,
              url: api_url,
              data: payload,
              headers: { "Content-Type": "application/json" },
            })
              .then(function (response) {
                _this.$toaster.success(response.data.message);
                _this.$router.push({ name: "ProvisionList" });
              })
              .catch((errors) => {
                if (errors.response && errors.response.data) {
                  const errorDetails = errors.response.data.errors || {};
                  console.log(errorDetails);
                  if (
                    errorDetails.hasOwnProperty("code") &&
                    errorDetails.code == 501
                  ) {
                    // If API sends a general message (non-field specific)
                    if (errorDetails.message) {
                      _this.$toaster.error(errorDetails.message);
                    }
                  } else {
                    // Map API errors to VeeValidate field names
                    Object.keys(errorDetails).forEach((key) => {
                      const simpleKey = key.split(".").pop(); // last part after dot
                      const message = errorDetails[key][0];

                      // Toast notification
                      _this.$toaster.error(message);

                      // Inline VeeValidate error
                      _this.errors.add({
                        field: simpleKey,
                        msg: message,
                      });
                    });
                  }
                } else {
                  _this.$toaster.error("An unexpected error occurred.");
                }
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        })
        .catch((error) => {
          console.log("error " + error);
          // reject(error)
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/provisions/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getRouterList: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/get-routers";
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    getSubnetMasks: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/get-provision-subnet-masks";
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            let res_data = response.data;
            if (!res_data.hasOwnProperty("voip_configuration")) {
              res_data.voip_configuration = {};
            }
            if (!res_data.hasOwnProperty("application_alias")) {
              res_data.application_alias = { voip_enable: 0 };
            }
            if (res_data.application_alias.voip_enable == 1) {
              if (
                !res_data.voip_configuration.hasOwnProperty("codec_setting") ||
                res_data.voip_configuration.codec_setting == null ||
                res_data.voip_configuration.codec_setting.length == 0
              ) {
                res_data.voip_configuration.codec_setting = this.codecs;
              }
            } else {
              res_data.voip_configuration = {};
            }
            if (
              !(
                res_data.hasOwnProperty("initial_configuration") &&
                res_data.initial_configuration.hasOwnProperty(
                  "lan_configure_automatically"
                )
              )
            ) {
              res_data.initial_configuration.lan_configure_automatically = 0;
            }
            if (
              !(
                res_data.hasOwnProperty("initial_configuration") &&
                res_data.initial_configuration.hasOwnProperty(
                  "wan_configure_automatically"
                )
              )
            ) {
              res_data.initial_configuration.wan_configure_automatically = 0;
            }
            if (
              !res_data.initial_configuration ||
              _.isEmpty(res_data.initial_configuration.username)
            ) {
              res_data.initial_configuration.username = res_data.name;
            }
            if (
              !res_data.initial_configuration ||
              _.isEmpty(res_data.initial_configuration.activation_email)
            ) {
              res_data.initial_configuration.activation_email = res_data.email;
            }

            this.value = res_data;
          })
          .catch((errors) => {
            console.error(errors);
            if (errors.hasOwnProperty("response")) {
              if (errors.response.status === 501) {
                this.$toaster.error(errors.response.data.errors.message);
                this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                this.$toaster.error(errors.response.data.message);
                this.$setErrorsFromResponse(errors.response.data);
              }
            }
            // this.$router.back()
          });
      }

      await this.getSubnetMasks()
        .then((response) => {
          this.pre.subnetMasks = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
      await this.getRouterList()
        .then((response) => {
          this.pre.routerList = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getTimeZone()
        .then((response) => {
          this.pre.timeZoneList = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    setDHCPIP() {
      const ipAddress = this.value.initial_configuration.lan_ip;
      const subnetMask = this.value.initial_configuration.lan_subnet_mask;

      const cidr = ipAddress + "/" + subnetMask;
      const ranges = this.getIpRangeFromAddressAndNetmask(cidr);

      const startRange = ranges[0].split(".");
      startRange[3] = (parseInt(startRange[3], 10) + 2).toString();
      const startIp = startRange.join(".");

      const endRange = ranges[1].split(".");
      endRange[3] = (parseInt(endRange[3], 10) - 2).toString();
      const endIp = endRange.join(".");

      this.value.initial_configuration.lan_start_ip = startIp;
      this.value.initial_configuration.lan_end_ip = endIp;
    },

    getIpRangeFromAddressAndNetmask(str) {
      var part = str.split("/");
      var ipaddress = part[0].split(".");
      var netmaskblocks = ["0", "0", "0", "0"];
      if (!/\d+\.\d+\.\d+\.\d+/.test(part[1])) {
        netmaskblocks = (
          "1".repeat(parseInt(part[1], 10)) +
          "0".repeat(32 - parseInt(part[1], 10))
        ).match(/.{1,8}/g);
        netmaskblocks = netmaskblocks.map((el) => {
          return parseInt(el, 2);
        });
      } else {
        netmaskblocks = part[1].split(".").map((el) => {
          return parseInt(el, 10);
        });
      }
      var invertedNetmaskblocks = netmaskblocks.map((el) => {
        return el ^ 255;
      });
      var baseAddress = ipaddress.map((block, idx) => {
        return block & netmaskblocks[idx];
      });
      var broadcastaddress = baseAddress.map((block, idx) => {
        return block | invertedNetmaskblocks[idx];
      });
      return [baseAddress.join("."), broadcastaddress.join(".")];
    },

    setNetwork() {
      if (
        this.value.initial_configuration.wan_isp_type == "unify" ||
        this.value.initial_configuration.wan_isp_type == "maxis"
      ) {
        this.value.initial_configuration.wan_network_type = "pppoe";
      }
    },

    getTimeZone: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get-time-zone";
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
  },
  mounted() {
    this.initialize();
  },
  created() {
    // this.$emit("update:layout", MasterLayout);
    this.$validator.localize("en", {
      attributes: {
        display_name: "Caller ID",
        sip_number: "VOip number",
        sip_port: "Sip Port",
        sip_server: "SIP Server",
        login_id: "Login ID",
        password: "Password",
        proxy_server: "Proxy Server",
        proxy_port: "Proxy Port",
        activation_email: "Email",
        device_name: "Device Name",
        wan_static_ip_address: "IP Address",
        wan_static_subnet_mask: "Subnet Mask",
        wan_static_default_gateway: "Default Gateway",
        wan_static_preferred_dns: "Preferred DNS",
        lan_ip: "IP Address",
        lan_subnet_mask: "Subnet Mask",
        lan_start_ip: "Start IP",
        lan_end_ip: "End IP",
        username: "Name",
      },
      messages: {
        // Define a custom message for the 'required' rule
        // Use {_field_} placeholder to inject the mapped name
        required: (field) => `The ${field} is required`,
        alpha_num: (field) => `The ${field} must be alphanumeric.`, // Example of a message that already uses the placeholder
      },
    });
  },
};
</script>
<style scoped>
a[aria-expanded="true"] i::before {
  content: "\e917";
}

a[aria-expanded="true"]:hover {
  color: #111;
}

.theme-audra .table > tbody > tr > td:first-child {
  color: #657182;
}

.table > tbody > tr > td:first-child {
  font-weight: normal;
}

.theme-audra .table > thead > tr > th[data-v-532122d6] {
  background-color: #f9f9f9;
  border: none !important;
  color: #1e1e1e;
}

.theme-audra .table > thead > tr > th:first-child {
  border-radius: 8px 0 0 8px;
}

.theme-audra .table > thead > tr > th:last-child {
  border-radius: 0 8px 8px 0;
}

.table td,
.table th {
  padding: 1rem;
  vertical-align: middle;
  border: none !important;
}

.table > tbody > tr > td:last-child,
.table > thead > tr > th:last-child {
  text-align: start;
}

.table > tbody > tr:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 0.7);
}

.readonly {
  background-color: #e9ecef;
  opacity: 1;
}
</style>
